import React from "react"
import { Card, CardBody, Badge, Button } from "reactstrap"

const SecurityAlerts = () => {
  // Dummy data for security alerts - replace with real API data
  const securityData = {
    criticalAlerts: 2,
    warningAlerts: 5,
    infoAlerts: 12,
    alerts: [
      {
        id: 1,
        type: "critical",
        title: "Multiple Failed Login Attempts",
        description: "User account locked due to 5+ failed attempts",
        time: "5 mins ago",
        action: "Review Account"
      },
      {
        id: 2,
        type: "critical", 
        title: "Suspicious Payment Activity",
        description: "Unusual transaction pattern detected",
        time: "12 mins ago",
        action: "Check Transactions"
      },
      {
        id: 3,
        type: "warning",
        title: "High Server Load",
        description: "CPU usage above 85% for 10+ minutes",
        time: "25 mins ago",
        action: "Monitor System"
      },
      {
        id: 4,
        type: "warning",
        title: "Unusual User Registration Pattern",
        description: "50+ registrations from same IP range",
        time: "1 hour ago",
        action: "Investigate"
      },
      {
        id: 5,
        type: "info",
        title: "Scheduled Maintenance Reminder",
        description: "Database maintenance scheduled for tonight",
        time: "2 hours ago",
        action: "Acknowledge"
      }
    ]
  }

  const getAlertColor = (type) => {
    switch (type) {
      case 'critical': return 'danger'
      case 'warning': return 'warning'
      case 'info': return 'info'
      default: return 'secondary'
    }
  }

  const getAlertIcon = (type) => {
    switch (type) {
      case 'critical': return 'mdi-alert-circle'
      case 'warning': return 'mdi-alert-triangle'
      case 'info': return 'mdi-information'
      default: return 'mdi-bell'
    }
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h4 className="card-title mb-0">Security Alerts</h4>
          <div className="d-flex gap-2">
            <Badge color="danger" className="badge-soft">
              {securityData.criticalAlerts} Critical
            </Badge>
            <Badge color="warning" className="badge-soft">
              {securityData.warningAlerts} Warning
            </Badge>
          </div>
        </div>

        <div className="alert-feed" style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {securityData.alerts.map((alert) => (
            <div key={alert.id} className="d-flex align-items-start mb-3 p-3 border rounded">
              <div className={`avatar-sm rounded-circle bg-${getAlertColor(alert.type)} d-flex align-items-center justify-content-center me-3`}>
                <i className={`mdi ${getAlertIcon(alert.type)} text-white`}></i>
              </div>
              <div className="flex-1">
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <h6 className="mb-0">{alert.title}</h6>
                  <Badge color={getAlertColor(alert.type)} className="badge-soft">
                    {alert.type}
                  </Badge>
                </div>
                <p className="text-muted mb-2 font-size-13">{alert.description}</p>
                <div className="d-flex align-items-center justify-content-between">
                  <small className="text-muted">{alert.time}</small>
                  <Button 
                    color={getAlertColor(alert.type)} 
                    size="sm" 
                    outline
                    className="btn-xs"
                  >
                    {alert.action}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-3 pt-3 border-top">
          <Button color="primary" size="sm" outline>
            <i className="mdi mdi-shield-check me-1"></i>
            View Security Dashboard
          </Button>
        </div>
      </CardBody>
    </Card>
  )
}

export default SecurityAlerts